/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
(function() {
'use strict';

/**
 * Controller for Verify Email Alert.
 */
angular.module('bulbApp.alertsModule')

.controller('VerifyEmailAlertController', VerifyEmailAlertController);

function VerifyEmailAlertController() {}

}());
